export default "__VITE_ASSET__CkotVsDm__"